import React from 'react';
import { Link } from 'react-router-dom';
import { FEED_RADII, hasCoordinates } from '../locationFeed';
import LocationAutocomplete from './LocationAutocomplete';

export default function FeedLocationControls({ center, radius, setRadius, elsewhere, setElsewhere, setCenter }) {
  return <section className="feed-location-controls" aria-label="Feed location">
    <p className="feed-center">{center?.label || 'Choose location'}</p>
    <div className="radius-options" role="group" aria-label="Coverage radius">{FEED_RADII.map(({ label, km }) => <button key={label} type="button" className={radius === km ? 'active' : ''} aria-pressed={radius === km} title={km === null ? 'Worldwide' : `Within ${km} km`} onClick={() => setRadius(km)}>{label}</button>)}</div>
    <button type="button" className="text-button" onClick={() => setElsewhere(!elsewhere)}>{elsewhere ? 'Use my profile location' : 'Browse another location'}</button>
    {elsewhere && <LocationAutocomplete value={center} onChange={setCenter} />}
    {!hasCoordinates(center) && radius !== null && <p className="form-error" role="alert">Select a location to browse nearby, <Link to="/profile/edit">update your profile location</Link>, or choose Global.</p>}
  </section>;
}
